import { Directive, TemplateRef, ViewContainerRef } from '@angular/core';
import { AuthService } from '../services/auth.service';

@Directive({
  selector: '[msoAccess]'
})
export class SuperAdminAccessDirective {

  constructor(
    private auth: AuthService,
    private templateRef: TemplateRef<any>,
    private container: ViewContainerRef
  ) {
    this.menuAccessControl();
  }

  menuAccessControl(): void {
    if (!this.auth.isLCO()) {
      // is MSO
      this.container.createEmbeddedView(this.templateRef);
    } else {
      // is LCO and doesn't have permission
      this.container.clear();
    }
  }


}
